export default function CastCard({cast}){
    
    return(
        <div className="pr-1">
            
<div class=" bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800  dark:border-gray-700" style={{width:"100px" , height: "200px"}}>
    
        <img class="rounded-t-lg" src={cast.profilePict} alt=""/>
        <h1 className="pl-1">{cast.name}</h1>
</div>

        </div>
    )
}